import { render } from "./LandscapePage.vue?vue&type=template&id=746f82fc&scoped=true"
import script from "./LandscapePage.vue?vue&type=script&lang=js"
export * from "./LandscapePage.vue?vue&type=script&lang=js"

import "./LandscapePage.vue?vue&type=style&index=0&id=746f82fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746f82fc"]])

export default __exports__